export default __webpack_public_path__ + "call-us-image-908772a31481dae95a4c42023d62c462.digested.jpg";